import React, { useState, useContext } from "react";
import { ModalPricesContainer, ProfileImage } from "./ModalPricesStyled";
import close from './../../utils/images/close_circle.svg';
import avatar from './../../utils/images/avatar_fluincr.png';
import Slider from '@mui/material/Slider';

import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { utils } from '@hassanmojab/react-modern-calendar-datepicker';

import { FormattedMessage, useIntl } from 'react-intl';
import { postEditUserDataInfluencer } from "../../api/myAccountApi";
import { UserContext } from "../../context/userContext";
import Spinner from "../Spinner/Spinner";
import Alert from "../Alert/Alert";
import { useEffect } from "react";
import { getServices } from "../../api/generalApi";
import { LangContext } from "../../context/langContext";
import { postServicesPricesByInfluencer } from "../../api/influencerApi";

export default function ModalPrices({ setShowModalPrices }) {

    const intl = useIntl();
    const { locale } = useContext(LangContext);

    const [services, setServices] = useState([]);

    const [startPrice, setStartPrice] = useState();

    const [porcent, setPorcent] = useState(null);
    const [manyCode, setManyCode] = useState(null);
    const [expiration, setExpiration] = useState(null);

    const [showCode, setShowCode] = useState(false);

    /* const [photoPrice, setPhotoPrice] = useState(null);
    const [video30Price, setVideo30Price] = useState(null);
    const [video60Price, setVideo60Price] = useState(null);
    const [videoPlusPrice, setVideoPlusPrice] = useState(null); */

    const { userToken, personalFare, setPersonalFare, imageProfile } = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(true);
    const [showSuccessfulAlert, setShowSuccessfulAlert] = useState(false);

    useEffect(() => {
        getServices().then((response) => {
            let auxService = response;
            auxService.map((service, index) => {
                for (let i = 0; i < personalFare.length; i++) {
                    if (service.id === personalFare[i].services) {
                        auxService[index].rate = personalFare[i].rate
                    }

                }
            })

            setServices(auxService)
            setIsLoading(false);
        })
    }, [personalFare])

    const handleChangePrice = (event, newValue) => {
        setStartPrice(newValue);
        //setEndPrice(newValue[1]);
    };

    const generateCode = () => {
        setShowCode(true);
    }

    /*  useEffect(() => {
         setPhotoPrice(personalFare.photo);
         setVideo30Price(personalFare.video30);
         setVideo60Price(personalFare.video60);
         setVideoPlusPrice(personalFare.videoPlus);
     }, [personalFare]) */

    const saveChange = () => {
        setIsLoading(true);

        let servicesPrices = [];

        services.map((service) => {
            if (service.rate !== null && service.rate !== undefined) {
                servicesPrices.push({ services: service.id, rate: Number(service.rate) })
            }
        })

        postServicesPricesByInfluencer({ servicesPrices: servicesPrices, token: userToken }).then((response) => {
            setIsLoading(false);
            if (response.status === 201) {
                setPersonalFare(servicesPrices)
            }
        })

        /* setIsLoading(true);
        const auxBody = {
            personalFare: {

            }
        }
        const auxPerfonalFare = personalFare;
        if (photoPrice !== null) {
            auxBody.personalFare.photo = Number(photoPrice);
            auxPerfonalFare.photo = Number(photoPrice);
            setPersonalFare(auxPerfonalFare)
        }
        if (video30Price !== null) {
            auxBody.personalFare.video30 = Number(video30Price);
            auxPerfonalFare.video30 = Number(video30Price);
            setPersonalFare(auxPerfonalFare)
        }
        if (video60Price !== null) {
            auxBody.personalFare.video60 = Number(video60Price);
            auxPerfonalFare.video60 = Number(video60Price);
            setPersonalFare(auxPerfonalFare)
        }
        if (videoPlusPrice !== null) {
            auxBody.personalFare.videoPlus = Number(videoPlusPrice);
            auxPerfonalFare.videoPlus = Number(videoPlusPrice);
            setPersonalFare(auxPerfonalFare)
        }

        postEditUserDataInfluencer({ body: auxBody, token: userToken }).then((response) => {
            setIsLoading(false);
            if (response.status === 201) {
                setShowSuccessfulAlert(true);
            }
        }) */
    }

    const renderCustomInput = ({ ref }) => (
        <input
            readOnly
            ref={ref}
            placeholder={intl.formatMessage({ id: "modal_prices_text_3" })}
            value={expiration ? `${expiration.day}/${expiration.month}/${expiration.year}` : ''}
            style={{
                padding: '9px',
                fontSize: '0.8rem',
                border: '1px solid #BCBCBC',
                borderRadius: '5px',
                outline: 'none',
                fontFamily: 'Open Sans'

            }}
            className="my-custom-input-class"
        />
    );

    const changeRate = (event, index) => {
        let auxServices = [...services];
        auxServices[index].rate = event.target.value;
        setServices(auxServices);
    }

    const handleInputChangeRate = (event, index) => {
        if (/^\d*$/.test(event.target.value)) {
            changeRate(event, index)
        }
    };

    return (
        <ModalPricesContainer>

            <div className="pricesBody">
                <img src={close} alt="close" className="close" onClick={() => { setShowModalPrices(false) }} />

                <div className="headerTable">
                    <ProfileImage image={(imageProfile !== null) ? (imageProfile) : (avatar)} />
                </div>

                <table>
                    <tr>
                        <th><ProfileImage image={(imageProfile !== null) ? (imageProfile) : (avatar)} /></th>
                        <th><FormattedMessage id="modal_prices_subTitle_1" defaultMessage="$ por 1000 seguidores" /></th>
                        <th><FormattedMessage id="modal_prices_subTitle_2" defaultMessage="Precio" /></th>
                    </tr>
                    {services.map((service, index) => {
                        return (
                            <tr>
                                <td ><p className="type">{(locale === 'es-CO') ? service.nombre : service.name}</p></td>
                                <td><Slider
                                    aria-label="Temperature"
                                    defaultValue={service.pricesuggested}
                                    valueLabelDisplay="auto"
                                    max={1000}
                                    value={startPrice}
                                    //onChange={handleChangePrice}
                                    className='slider'
                                /></td>
                                <td >{/* <input type='number' value={service.rate} onChange={(event) => { changeRate(event, index) }} className="inputPrice" placeholder="USD" /> */}<input type="text" value={service.rate} onChange={(event) => { handleInputChangeRate(event, index) }} /></td>
                            </tr>
                        )
                    })}
                    {/* <tr>
                        <td ><p className="type"><FormattedMessage id="modal_prices_option_1" defaultMessage="Foto" /></p></td>
                        <td><Slider
                            aria-label="Temperature"
                            defaultValue={30}
                            valueLabelDisplay="auto"
                            max={1000}
                            value={startPrice}
                            onChange={handleChangePrice}
                            className='slider'
                        /></td>
                        <td ><input type='number' value={photoPrice} onChange={(event) => { setPhotoPrice(event.target.value) }} className="inputPrice" placeholder="USD" /></td>
                    </tr>
                    <tr>
                        <td ><p className="type"><FormattedMessage id="modal_prices_option_2" defaultMessage="Video 30" /></p></td>
                        <td><Slider
                            aria-label="Temperature"
                            defaultValue={30}
                            valueLabelDisplay="auto"
                            max={1000}
                            value={startPrice}
                            onChange={handleChangePrice}
                            className='slider'
                        /></td>
                        <td><input type='number' value={video30Price} onChange={(event) => { setVideo30Price(event.target.value) }} className="inputPrice" placeholder="USD" /></td>
                    </tr>
                    <tr>
                        <td ><p className="type"><FormattedMessage id="modal_prices_option_3" defaultMessage="Video 60" /></p></td>
                        <td><Slider
                            aria-label="Temperature"
                            defaultValue={30}
                            valueLabelDisplay="auto"
                            max={1000}
                            value={startPrice}
                            onChange={handleChangePrice}
                            className='slider'
                        /></td>
                        <td><input type='number' value={video60Price} onChange={(event) => { setVideo60Price(event.target.value) }} className="inputPrice" placeholder="USD" /></td>
                    </tr>
                    <tr>
                        <td ><p className="type"><FormattedMessage id="modal_prices_option_4" defaultMessage="Video plus" /></p></td>
                        <td><Slider
                            aria-label="Temperature"
                            defaultValue={30}
                            valueLabelDisplay="auto"
                            max={1000}
                            value={startPrice}
                            onChange={handleChangePrice}
                            className='slider'
                        /></td>
                        <td><input type='number' value={videoPlusPrice} onChange={(event) => { setVideoPlusPrice(event.target.value) }} className="inputPrice" placeholder="USD" /></td>
                    </tr> */}

                </table>

                {/* <div className="discountGenerator">
                    <p><FormattedMessage id="modal_prices_text_1" defaultMessage="Generar código de descuento" /></p>
                    <div className="inputs">
                        <div className="porcent">
                            <input type="number" max={100} placeholder="#" onChange={(event) => { setPorcent(event.target.value) }} />
                            <p className="porcentSymbol">%</p>
                        </div>

                        <input type="number" placeholder={intl.formatMessage({ id: "modal_prices_text_2" })} onChange={(event) => { setManyCode(event.target.value) }} />

                        <DatePicker
                            value={expiration}
                            onChange={setExpiration}
                            calendarClassName="custom-calendar"
                            renderInput={renderCustomInput}
                            colorPrimary="#E8339E"
                            minimumDate={utils().getToday()}

                            //Comentar este boton
                         renderFooter={() => (
                            <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setExpiration(null)
                                    }}
                                    style={{
                                        border: '#0fbcf9',
                                        color: '#fff',
                                        borderRadius: '0.5rem',
                                        padding: '5px 20px',
                                        backgroundColor: '#E8339E',
                                        margin: '0'
                                    }}
                                >
                                    <FormattedMessage id="modal_prices_text_5" defaultMessage="Restablecer valor" />
                                </button>
                            </div>
                        )} 
                        />

                    </div>

                    <button className="generateButton" onClick={generateCode}><FormattedMessage id="modal_prices_button_1" defaultMessage="Generar código" /></button>
                </div> */}

                {(showCode) && (<p className="text">{porcent}<FormattedMessage id="modal_prices_text_4" defaultMessage=" % código de descuento (vencimiento " /> {expiration?.day}/{expiration?.month}/{expiration?.year} ({manyCode}): X123XXX567AG </p>)}

                <div className="buttonContainer">
                    <button className="saveButton" onClick={saveChange}><FormattedMessage id="modal_prices_button_2" defaultMessage="Guardar cambios" /></button>
                </div>

            </div>

            {(isLoading) && (<Spinner />)}

            {(showSuccessfulAlert) && (<Alert
                title={<FormattedMessage id="alert_forward_title" defaultMessage="¡Exitoso!" />}
                text={<FormattedMessage id="alert_change_successful_text" defaultMessage="Los cambios se han realizado con éxito." />}
                setShowAlert={setShowSuccessfulAlert}
            />)}
        </ModalPricesContainer>
    )
}